import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Chart } from './Chart';
import styles from './ChartCard.module.css';
export function ChartCard({ title, target, subLabel, data, lineColor, areaColor }) {
    return (_jsxs("div", { className: styles.card, children: [_jsxs("div", { className: styles.header, children: [_jsx("div", { className: styles.title, children: title }), _jsx("div", { className: styles.target, children: target })] }), subLabel && _jsx("div", { className: styles.subLabel, children: subLabel }), _jsx(Chart, { data: data, lineColor: lineColor, areaColor: areaColor })] }));
}
